export default {
  created () {
    if (this.$route.query.utm) {
      this.$cookies.set('utm', this.$router.currentRoute.query.utm)
    }
  },
  async mounted () {
    await this.$store.dispatch('auth/fetchMe')
      .catch((e) => {
        return e
      })
    if (!this.$store.getters['auth/isGuest']) {
      if (window.localStorage.getItem('watchList')) {
        await this.$store.dispatch('watchList/getWithExpiry', 'watchList')
      } else {
        await this.$store.dispatch('watchList/getWatchList')
      }
    }
  },
  methods: {
    async getNewAndTrends (store, fapi, arzypto) {
      try {
        const trends = await store.dispatch('axios/get', { url: fapi + '/fapi/trends' })
        store.commit('coins/set_data', { stateName: 'trends', data: trends.data.data })
      } catch (e) {
        return e
      }
      // try {
      //   const latestSymbols = await store.dispatch('axios/get', { url: '/application/coin/latest', config: { baseURL: process.env.BASE_ASYNC_UUID } })
      //   const latest = await store.dispatch('axios/get', { url: fapi + '/fapi/coinsFilter', config: { params: { symbols: latestSymbols.data.data.symbols.toString() } } })
      //   store.commit('coins/set_data', { stateName: 'latest', data: latest.data.data })
      // } catch (e) {
      //   return e
      // }
      try {
        const news = await store.dispatch('axios/get', { url: arzypto + '/academy/news' })
        store.commit('coins/set_data', { stateName: 'news', data: news.data.data })
      } catch (e) {
        return e
      }
    },
    async getLoseAndGain (store) {
      try {
        const res = await store.dispatch('axios/get', {
          url: '/market/list',
          config: { baseURL: process.env.BASE_ASYNC_EXCHANGE_URL }
        })

        const markets = res.data.data.markets.slice(0, 15)
        const pairs = markets.flatMap(item => [
          item.symbol,
          `${item.base}USDT`
        ])
        const resp = await store.dispatch('axios/get', {
          url: '/application/coin/priceList',
          config: {
            baseURL: process.env.ASYNC_BASE_URL_API,
            params: { symbols: pairs.join() }
          }
        })

        const prices = resp.data.data
        const merged = markets.map((market) => {
          const priceIRT = prices.find(p => p.pair === market.symbol)
          const priceUSDT = prices.find(p => p.pair === `${market.base}USDT`)
          return {
            ...market,
            priceIRT: priceIRT ? Number(priceIRT.price) : null,
            priceUSDT: priceUSDT ? Number(priceUSDT.price) : null
          }
        })

        const sorted = merged.sort((a, b) => Number(b.change24h) - Number(a.change24h))
        store.commit('coins/set_data', { stateName: 'gainer', data: sorted })
      } catch (e) {
        return e
      }
    }

  }
}
